module.exports = {
  initScroll: function ($target, options) {
    $target = $target || this.$el;

    var $activeAccordion = $target.find('.accordion dd:visible');
    var hasActiveAccordion = $activeAccordion.length;
    if (hasActiveAccordion) return this.initScroll($activeAccordion, options);

    var options = $.extend({
      autoHide: false,
      width: this.getScrollWidth($target),
      height: this.getScrollHeight($target)
    }, options);

    $target.hasClass('antiscroll-wrap')
      ? $target.antiscroll(options)
      : $target.find('.antiscroll-wrap').antiscroll(options);
  },

  getScrollWidth: function ($target) {
    return $target.parents('.tool-content').width();
  },

  getScrollHeight: function ($target) {
    return $target.parents('.tool-content').height();
  },

  toggleScroll: function (value) {
    var $wrapper = this.$el.find('.antiscroll-wrap:first');

    $wrapper.children('.antiscroll-inner')
      .css('overflow', value ? 'hidden' : 'auto');

    $wrapper.children('.antiscroll-scrollbar')
      .toggleClass('antiscroll-scrollbar-shown', !value);
  }
};
